var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button } from "@/components/ui/Button";
import { LoadingSpinner } from "@/components/ui/LoadingSpinner";
import { cn } from "@/lib/utils";
import { hasAvaliacaoConfig } from "@/utils/avalieRedirect";
import { handleServiceAssessment } from "@/utils/handleServiceAssessment";
import { useCallback, useState } from "react";
export function EvaluateServiceButton() {
    var _a = useState(false), loading = _a[0], setLoading = _a[1];
    var _b = useState(""), error = _b[0], setError = _b[1];
    var handleClick = useCallback(function () {
        handleServiceAssessment(setLoading, setError);
    }, []);
    if (!hasAvaliacaoConfig()) {
        return null;
    }
    return (_jsxs("div", __assign({ className: "flex w-full max-w-[856px] flex-col items-center justify-center gap-2 py-6" }, { children: [error && _jsx("p", __assign({ className: "text-center text-sm text-destructive" }, { children: error })), !error && (_jsxs(Button, __assign({ type: "button", variant: "ghost", onClick: handleClick, disabled: loading, className: cn("bg-transparent text-etipi-blue hover:bg-transparent hover:text-dark-blue-500") }, { children: [loading && _jsx(LoadingSpinner, { className: "text-etipi-blue" }), "Avaliar servi\u00E7o"] })))] })));
}
